import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

interface TableColumn {
  key: string;
  label: string;
  width?: string;
}

interface TableData {
  [key: string]: any;
}

@Component({
  selector: 'app-notification-popup',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './notification-popup.component.html',
  styleUrls: ['./notification-popup.component.scss']
})
export class NotificationPopupComponent {
  @Input() message = '';
  @Input() showHeader = true;
  @Input() showFooter = true;
  @Input() headerTitle = '';
  @Input() size: 'sm' | 'md' | 'lg' = 'sm';
  @Input() tableData: TableData[] = [];
  @Input() tableColumns: TableColumn[] = [];
  @Input() showTable = false;
  @Input() footerButtons: { label: string; action: string; class: string }[] = [
    { label: 'Close', action: 'close', class: 'btn-secondary' }
  ];
  @Output() close = new EventEmitter<void>();
  @Output() action = new EventEmitter<string>();

  onClose() {
    this.close.emit();
  }

  onAction(action: string) {
    this.action.emit(action);
    if (action === 'close') {
      this.close.emit();
    }
  }
} 